<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="`left`"
        :label-width="$device.mobile ? `` : `100px`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :sm="8">
            <el-form-item :label="$t('계정ID')">
              <el-input v-model="searchForm.accountId" @keyup.enter.native="searchFirstPage" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('만료 여부')">
              <combo
                :data="mainVue.code.nonExpired"
                :label="$t('전체')"
                :model="searchForm.nonExpired"
                @change="searchForm.nonExpired = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="8">
            <el-form-item :label="$t('사용자명')">
              <el-input v-model="searchForm.accountNm" @keyup.enter.native="searchFirstPage" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('잠금 여부')">
              <combo
                :data="mainVue.code.nonLocked"
                :label="$t('전체')"
                :model="searchForm.nonLocked"
                @change="searchForm.nonLocked = $event"></combo>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('인증 만료 여부')">
              <combo
                :data="mainVue.code.certificateNonExpired"
                :label="$t('전체')"
                :model="searchForm.certificateNonExpired"
                @change="searchForm.certificateNonExpired = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('AccountSearch')"
        :size="size"
        @click="searchFirstPage"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('AccountAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('AccountUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('AccountDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('AccountAuth')"
        :size="size"
        @click="openAuth"
        icon="el-icon-setting"
        :disabled="btn.openAuthDisabled"
        >{{ $t('권한 설정') }}</el-button
      >

      <!-- 열지 못한 이유는 **목록 화면**에 남는다 — 다이얼로그를 열지 않았으므로 폼에는 쓸 자리가 없다.
           `.buttons` **안**에 두는 이유: 표 높이는 `.search_form`·`.buttons` 만 재므로(MenuFrame) 밖에 두면 표가 넘친다 -->
      <el-alert
        v-if="accountReadDenied"
        class="account-read-denied"
        type="warning"
        :title="accountReadDenied"
        show-icon
        @close="accountReadDenied = ''" />
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight - 48"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked"
      @sort-change="handleSortChange">
      <el-table-column
        :label="totalElements.toString()"
        type="index"
        width="55"
        align="center"
        fixed
        label-class-name="data_cnt"
        :index="indexMethod"></el-table-column>
      <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>
      <!-- 정렬은 **서버**가 한다(`sortable="custom"`) — 페이징된 목록에서 `sortable` 은 「이 페이지 안에서만」이라
           사람이 본 순서와 서버가 고른 50건이 서로 다른 말을 한다. 열의 `prop` 이 곧 서버로 가는 `sortProp` 이다 -->
      <el-table-column
        :label="$t('계정ID')"
        prop="accountId"
        min-width="100"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('사용자명')"
        prop="accountNm"
        min-width="100"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('핸드폰 번호')"
        prop="tel"
        :formatter="util.telCell"
        min-width="130"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('이메일')"
        prop="email"
        min-width="150"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('최종 로그인 시간')"
        prop="lastLoginDtm"
        min-width="100"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <!-- 			<el-table-column :label="$t('비번변경 시간')" prop="passChangeDtm" min-width="150" sortable show-overflow-tooltip></el-table-column> -->
      <el-table-column
        :label="$t('사용 가능 여부')"
        prop="useYn"
        min-width="100"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
      <el-table-column
        :label="$t('잠금 여부')"
        prop="nonLocked"
        min-width="100"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
      <el-table-column
        :label="$t('만료 여부')"
        prop="nonExpired"
        min-width="100"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
      <el-table-column
        :label="$t('인증 만료 여부')"
        prop="certificateNonExpired"
        min-width="120"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
    </el-table>
    <list-pagination
      :search-form="searchForm"
      :total="totalElements"
      @page-change="handlePageChange"
      @size-change="handleSizeChange"></list-pagination>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        label-width="180px"
        :label-position="$device.mobile ? 'top' : 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="12">
            <el-form-item :label="$t('계정ID')" :error="formError.accountId" required>
              <el-input
                v-model="inputForm.accountId"
                maxlength="50"
                clearable
                v-if="'I' === inputForm.statu"
                show-word-limit></el-input>
              <span v-else class="show_cd">{{ inputForm.accountId }}</span>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('사용자명')" :error="formError.accountNm" required>
              <el-input v-model="inputForm.accountNm" maxlength="50" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>

          <!-- 「비밀번호를 안 바꾼다」는 **빈칸**이다 — 종전처럼 서버가 준 bcrypt 해시를 되돌려 보내지 않는다
               (보안 원장 ⑥). 판정과 문구는 `utils/accountPassword` 한 곳이고, 생성에서만 필수다 -->
          <el-col :md="12">
            <el-form-item :label="$t('비밀번호')" :error="formError.accountPw" :required="passwordRequired">
              <el-input
                v-model="inputForm.accountPw"
                maxlength="60"
                type="password"
                clearable
                show-word-limit></el-input>
              <div v-if="!passwordRequired" class="account-password-hint">{{ passwordText.keepHint }}</div>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('비밀번호 확인')" :error="formError.accountPwConfirm" :required="passwordRequired">
              <el-input
                v-model="inputForm.accountPwConfirm"
                maxlength="60"
                type="password"
                clearable
                show-word-limit></el-input>
            </el-form-item>
          </el-col>

          <el-col :md="12">
            <el-form-item :label="$t('핸드폰 번호')" :error="formError.tel" required>
              <el-input
                v-keep-number-caret
                :value="util.telFieldText(inputForm.tel)"
                maxlength="20"
                clearable
                show-word-limit
                @input="inputForm.tel = util.telDigits($event)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('이메일')" :error="formError.email" required>
              <el-input v-model="inputForm.email" maxlength="100" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>

          <el-col :md="12">
            <el-form-item :label="$t('사용 가능 여부')" required>
              <combo :data="mainVue.code.useYn" :model="inputForm.useYn" @change="inputForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('잠금 여부')" required>
              <combo
                :data="mainVue.code.nonLocked"
                :model="inputForm.nonLocked"
                @change="inputForm.nonLocked = $event"></combo>
            </el-form-item>
          </el-col>

          <el-col :md="12">
            <el-form-item :label="$t('만료 여부')" required>
              <combo
                :data="mainVue.code.nonExpired"
                :model="inputForm.nonExpired"
                @change="inputForm.nonExpired = $event"></combo>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('인증 만료 여부')" required>
              <combo
                :data="mainVue.code.certificateNonExpired"
                :model="inputForm.certificateNonExpired"
                @change="inputForm.certificateNonExpired = $event"></combo>
            </el-form-item>
          </el-col>

          <!-- 역할과 범위 바인딩 — 계약 정본은 B2 서버 보고서 §3 이다(`auths` · `scopes:[{type,id}]`).
               발급할 수 있는 역할인지는 목록에서 빼지 않고 **서버가** 판정한다(`AccountIssuePolicy`).
               서버가 `issuable:false` 로 먼저 말해 주면 고를 수만 없게 한다(D1) — 빼면 까닭도 못 말한다. -->
          <el-col :md="12">
            <el-form-item :label="roleText.roleLabel" :error="formError.auths">
              <el-select
                v-model="selectedAuthIds"
                class="account-role"
                multiple
                filterable
                clearable
                :placeholder="rolePlaceholder">
                <el-option
                  v-for="role in roleOptions"
                  :key="role.authId"
                  :label="`${role.authNm} (${role.authId})`"
                  :value="role.authId"
                  :disabled="!roleIssuable(role)">
                  <el-tooltip :disabled="roleIssuable(role)" :content="roleText.roleNotIssuable" placement="right">
                    <span>{{ role.authNm }} ({{ role.authId }})</span>
                  </el-tooltip>
                </el-option>
              </el-select>
              <div class="account-hint">{{ roleText.roleHint }}</div>
              <!-- 목록이 사본으로 섰을 때만 — 서버 목록을 못 읽었다는 사실을 화면이 숨기지 않는다 -->
              <div v-if="roleCatalogFallback" class="account-hint account-role-fallback">
                {{ roleText.roleCatalogFallback }}
              </div>
            </el-form-item>
          </el-col>
          <!-- 세 범위 칸은 **고른 역할이 요구하면 필수**다(`scopeRequired`) — 소속 없이 만든 운영사·관리점·플레이스
               관리자 계정은 아무것도 보지 못한다. 비운 채 저장하면 보내지 않고 그 칸에 이유를 적는다(`checkScopeAxis`) -->
          <el-col :md="12" v-if="scopeAxes.place">
            <el-form-item :label="roleText.scopePlaceLabel" :error="formError.scopes" :required="scopeRequired.place">
              <!-- 후보를 못 읽으면 **읽기 전용**이다 — 고를 수 없는 칸에서 지우기만 되면 이미 묶인 범위가 조용히 사라진다 -->
              <el-select
                v-model="scopeForm.PLACE"
                class="account-scope-place"
                multiple
                filterable
                remote
                reserve-keyword
                clearable
                :disabled="!!placeScopeDenied"
                :remote-method="searchPlace"
                :loading="placeSearchLoading"
                :placeholder="placeScopeDenied || roleText.scopePlacePlaceholder"
                @focus="onPlaceFocus">
                <el-option
                  v-for="place in placeOptions"
                  :key="place.id"
                  :label="place.label"
                  :value="place.id"></el-option>
              </el-select>
              <div v-if="placeScopeDenied" class="account-hint account-scope-place-denied">{{ placeScopeDenied }}</div>
            </el-form-item>
          </el-col>
          <!--
            운영사·관리점 축은 **마스터 PK** 다(B7-b 서버 보고서 §8 4) — 종전의 자유 텍스트 갈래는 사라졌다.
            후보를 못 읽으면 플레이스와 **같은 규칙**으로 읽기 전용이다: 이미 묶인 범위는 그대로 저장에 실린다.
          -->
          <el-col :md="12" v-if="scopeAxes.operator">
            <el-form-item
              :label="roleText.scopeOperatorLabel"
              :error="formError.operator"
              :required="scopeRequired.operator">
              <el-select
                v-model="scopeForm.OPERATOR"
                class="account-scope-operator"
                multiple
                filterable
                clearable
                :disabled="!!operatorsDenied"
                :placeholder="operatorsDenied || roleText.scopeOperatorPlaceholder">
                <el-option
                  v-for="operator in bindableOperatorOptions"
                  :key="operator.id"
                  :label="operator.label"
                  :value="operator.id"></el-option>
              </el-select>
              <div v-if="operatorsDenied" class="account-hint account-scope-operator-denied">{{ operatorsDenied }}</div>
            </el-form-item>
          </el-col>
          <el-col :md="12" v-if="scopeAxes.agency">
            <el-form-item :label="roleText.scopeAgencyLabel" :error="formError.agency" :required="scopeRequired.agency">
              <AgencyPicker
                ref="agencyPicker"
                v-model="scopeForm.AGENCY"
                class="account-scope-agency"
                multiple
                :placeholder="roleText.scopeAgencyPlaceholder" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <!-- <el-button icon="el-icon-close" :size="size" @click="dialogFormVisible = false">{{ $t('닫기') }}</el-button> -->
        <el-button icon="el-icon-close" :size="size" @click="closeDialogVisible = true">{{ $t('닫기') }}</el-button>
      </div>
    </el-dialog>

    <!-- 권한 설정 팝업 -->
    <el-dialog :title="$t('권한 설정')" :visible.sync="authDialogFormVisible" fullscreen>
      <!-- 이 표도 사본 목록으로 설 수 있다(`AuthSearch` 가 없는 역할) — 그때는 최후 수단임을 말한다 -->
      <div v-if="roleCatalogFallback" class="account-hint account-role-fallback">
        {{ roleText.roleCatalogFallback }}
      </div>
      <!-- 역할 축의 답이 앉는 자리 — 이 팝업에는 폼이 없어 `el-form-item` 의 `:error` 가 쓸 곳이 없다
           (전부 해제한 저장을 막은 이유 · 서버 403 문구가 모두 여기로 온다) -->
      <div v-if="formError.auths" class="account-auth-error">{{ formError.auths }}</div>
      <el-table
        :height="popTableHeight"
        border
        stripe
        highlight-current-row
        tooltip-effect="dark"
        ref="authTable"
        :data="roleOptions"
        :size="size"
        :empty-text="$t('데이타 없음')"
        @select="authHandleRowChecked"
        @select-all="authHandleRowChecked">
        <el-table-column type="selection" width="45" align="center"></el-table-column>
        <el-table-column :label="$t('권한ID')" prop="authId" min-width="150" sortable></el-table-column>
        <el-table-column :label="$t('권한명')" prop="authNm" min-width="150" sortable></el-table-column>
        <el-table-column
          :label="$t('사용 가능 여부')"
          prop="useYn"
          min-width="100"
          align="center"
          :formatter="mainVue.formatterCode"></el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="closeDialogVisible = true">{{ $t('닫기') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="Warning"
      :visible.sync="closeDialogVisible"
      width="300px"
      :modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      center>
      <span>정말로 페이지를 닫으시겠습니까?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogVisible = false">아니요</el-button>
        <el-button
          type="primary"
          @click="
            closeDialogVisible = false
            authDialogFormVisible = false
            dialogFormVisible = false
          "
          >예</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AgencyPicker from '@/components/callpop/AgencyPicker.vue'
import { HttpError, mergeErrors } from '@/plugins/http'
import { canRead, permittedRead } from '@/plugins/http/permittedRead'
import { READ_DENIED, deniedRead, httpStatusOf } from '@/plugins/http/policy'
import { PASSWORD_TEXT, blankPassword, passwordPatch } from '@/utils/accountPassword'
import {
  ACCOUNT_WRITE_CONFIG,
  ROLE_TEXT,
  SCOPE_TYPE,
  adminRoleCatalog,
  authIdsOf,
  hasServerRoleRows,
  initScopeForm,
  missingScopesOf,
  placeOptionsOf,
  requiredScopeTypesOf,
  roleIssuable,
  scopeTypesOf,
  toScopeForm,
  toScopePayload,
} from '@/utils/adminRole'
import { bindableOrgOptions, keepSelectedOptions } from '@/utils/callpopOrg'
import { latestGuard } from '@/utils/latestGuard'
import { withPaging } from '@/utils/pagedList'
import { initData } from '@/utils/constants'
import callpopOperatorsMixin from '@/mixins/callpopOperatorsMixin'
import mainVueMixin from '@/mixins/mainVueMixin'
import pagedListMixin from '@/mixins/pagedListMixin'

/**
 * 이 화면이 **권한 밖일 수 있는 것을 읽는** 세 자리. 게이트와 403 옵트아웃은 [permittedRead] 한 곳이 갖는다.
 *
 * - 역할 목록 — 시스템 관리 리소스라 계정 발급만 받은 역할(콜팝 관리자)에는 없다. 액션이 없으면 **부르지
 *   않는다**: 보안 계층의 403 은 서버가 그 세션을 끊어 이후 모든 호출이 죽는다(compose 실측 2026-09-15).
 * - 계정 상세 — 서버 `AccountIssuePolicy.checkRead` 가 발급 사슬 밖 계정에 403 을 낸다. 목록은 이제 서버가
 *   같은 사슬로 거르지만(보안 원장 ②), 목록을 읽은 **뒤** 대상의 역할이 바뀌면 그 행의 상세는 403 이다 —
 *   옵트아웃이 없으면 그 한 번의 클릭이 로그아웃이다.
 * - 플레이스 후보 — 계정 발급 권한과 **다른 축**이다. 계정은 만들 수 있는데 `PlaceSearch` 는 없는 발급자가 있다.
 */
const AUTH_LIST_READ = { action: 'AuthSearch', url: '/auth', showLoading: false }
const PLACE_OPTIONS_READ = { action: 'PlaceSearch', url: '/place', showLoading: false }
/** 계정 상세 — `GET /account/*` 의 액션은 `AccountGet`(dev `sys_resources` 18 · res_tp_cd 3) */
const ACCOUNT_DETAIL_READ = { action: 'AccountGet', url: '/account' }

/** 범위 축 목록 → 템플릿이 읽는 세 칸의 참·거짓 — 「그리는가」와 「필수인가」가 같은 모양을 쓴다 */
const scopeAxisFlags = (types) => ({
  place: types.indexOf(SCOPE_TYPE.PLACE) > -1,
  operator: types.indexOf(SCOPE_TYPE.OPERATOR) > -1,
  agency: types.indexOf(SCOPE_TYPE.AGENCY) > -1,
})

/** 범위 축 → 그 칸의 오류 자리(`formError` 의 키) — 칸마다의 `el-form-item` 이 읽는 이름이다 */
const SCOPE_ERROR_FIELD = {
  [SCOPE_TYPE.PLACE]: 'scopes',
  [SCOPE_TYPE.OPERATOR]: 'operator',
  [SCOPE_TYPE.AGENCY]: 'agency',
}

export default {
  mixins: [mainVueMixin, pagedListMixin, callpopOperatorsMixin],

  components: { AgencyPicker },

  data: function () {
    var data = initData()
    data.url = '/account'

    // 권한 설정 부분
    data.btn.openAuthDisabled = true
    data.authDialogFormVisible = false

    data.authTableData = []

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.closeDialogVisible = false

    // 역할·범위 발급 (B2) — 폼 상태는 `inputForm` 과 따로 둔다: 서버로 나가는 모양(`auths`·`scopes`)과
    // 사람이 고르는 모양(id 목록·코드 문자열)이 다르고, 변환은 `utils/adminRole` 이 한다
    data.roleText = ROLE_TEXT
    /** 비밀번호 축의 문구 — 판정과 같은 파일이 소유한다(`utils/accountPassword`) */
    data.passwordText = PASSWORD_TEXT
    data.selectedAuthIds = []
    /**
     * 서버가 준 **이 계정의 현재 역할** — 고르는 중의 값([selectedAuthIds])과 따로 둔다.
     *
     * 역할 목록이 「고르는 중의 값」에 따라 다시 만들어지면 권한 설정 표의 `:data` 가 체크할 때마다 새 배열이
     * 되어 element-ui 가 선택을 지운다. 목록이 물어야 하는 것은 「이미 붙어 있는가」이고 그 답은 조회 시점에
     * 고정된다 — 사용 중지 역할을 목록에 남기는 판정([adminRoleCatalog])이 그것을 읽는다.
     */
    data.accountAuthIds = []
    data.scopeForm = initScopeForm()
    data.placeOptions = []
    data.placeSearchLoading = false
    /**
     * 후보 조회는 **겹친다** — 300ms 디바운스는 이미 나간 요청의 순서를 보장하지 않는다. 늦게 온 옛 응답이
     * 최신 검색어의 후보를 덮으면 사람이 친 낱말과 다른 플레이스가 범위 후보로 선다. 관용구는
     * `utils/latestGuard` 한 곳이다(패널·위저드가 같은 것을 쓴다).
     */
    data.placeGuard = latestGuard()
    // 못 읽었다는 답이 앉는 자리 — 계정 상세는 목록 화면에, 플레이스 후보는 그 칸에 남는다
    data.accountReadDenied = ''
    data.placeReadDenied = ''

    // `totalElements` 는 [pagedListMixin] 이 갖는다 — 페이지 UI 와 머리글 건수가 같은 값을 읽는다
    return data
  },
  computed: {
    /**
     * OPERATOR 축의 후보 — **활성 운영사 + 이미 묶인 것**(R-A). 비활성 운영사에 새 계정을 묶지 못하게 하되,
     * 이미 묶인 계정을 열었을 때 그 태그가 PK 숫자로 바뀌지 않게 한다(판정은 `bindableOrgOptions` 한 곳).
     * 관리점 축은 선택기의 검색이 이미 활성만 준다(`AgencyPicker`).
     */
    bindableOperatorOptions: function () {
      return bindableOrgOptions(this.operatorOptions, this.scopeForm[SCOPE_TYPE.OPERATOR])
    },
    /**
     * 고를 수 있는 역할 — `GET /auth` 가 정본이고, 막힌 역할에서만 사본 목록이 선다.
     *
     * **발급 셀렉트와 「권한 설정」 표가 같은 목록을 본다.** 종전에는 표만 `authTableData`(조회가 막히면 빈
     * 배열)를 직접 읽어, `AccountAuth` 는 있는데 `AuthSearch` 가 없는 계정(콜팝 관리자)에서 팝업이 빈 표였다.
     */
    roleOptions: function () {
      return adminRoleCatalog(this.authTableData, this.accountAuthIds)
    },
    /**
     * 목록이 **사본**으로 섰는가 — 그러면 화면이 그 사실을 말한다.
     *
     * 사본 목록([ADMIN_ROLE_NM])은 `GET /auth` 를 못 부른 경우의 **최후 수단**이고 DB 의 `sys_auth` 와
     * 동기화되지 않는다 — 없는 역할을 골라 저장하면 서버가 400(「존재하지 않는 권한입니다」)으로 답한다.
     * 「이 계정이 발급할 수 있는 역할」은 이제 서버가 `issuable` 로 답한다(D1). 사본 목록에는 그 값이
     * 없으므로 여기서는 전부 고를 수 있고, 판정은 저장할 때 선다 — 어느 갈래에서도 역할을 **숨기지 않는다**.
     * 출처 판정은 [adminRoleCatalog] 와 **같은 술어**를 읽는다.
     */
    roleCatalogFallback: function () {
      return !hasServerRoleRows(this.authTableData)
    },
    /**
     * 비밀번호가 **필수인가** — 생성에서만 그렇다.
     *
     * 수정에서 빈칸은 「지운다」가 아니라 「그대로 둔다」이므로(서버 `AccountPasswordPolicy.onUpdate`),
     * 필수 표시를 그대로 두면 화면이 서버와 다른 말을 한다. 안내 한 줄이 그 자리를 대신한다.
     */
    passwordRequired: function () {
      return 'I' === this.inputForm.statu
    },
    /** 역할 칸의 안내 — 「비우면 관리자」는 **생성에서만** 참이다(수정 PUT 에는 그 변환이 없다) */
    rolePlaceholder: function () {
      return 'I' === this.inputForm.statu ? this.roleText.rolePlaceholderNew : this.roleText.rolePlaceholderEdit
    },
    /** 이 계정이 다루는 범위 축 — 저장 페이로드와 **같은 함수**가 정한다(보이는 칸이 곧 보내는 값) */
    scopeAxes: function () {
      return scopeAxisFlags(scopeTypesOf(this.selectedAuthIds, this.scopeForm))
    },
    /**
     * 그 칸이 **필수인가** — 고른 역할이 요구하는 축이다(값이 있어서 보이기만 하는 축은 아니다).
     *
     * 판정은 칸을 그리는 것과 같은 자리(`utils/adminRole` 의 [requiredScopeTypesOf])가 한다 — 별표가 붙은
     * 칸과 저장 전 검사([checkScopeAxis])가 서로 다른 말을 하지 않는다.
     */
    scopeRequired: function () {
      return scopeAxisFlags(requiredScopeTypesOf(this.selectedAuthIds))
    },
    /**
     * 플레이스 후보를 **못 읽는 이유** — 빈 문자열이면 정상이다.
     *
     * 게이트는 조회를 소유한 [permittedRead] 와 **같은 술어**([canRead])를 읽는다: 화면이 `sa_actions` 를
     * 따로 세면 게이트가 둘이 되고, 그러면 한쪽만 고쳐질 때 칸은 열려 있는데 조회는 못 하는 상태가 된다.
     * 액션은 있는데 서버가 403 으로 답한 경우는 그 문장([placeReadDenied])이 답이다.
     */
    placeScopeDenied: function () {
      if (!canRead(PLACE_OPTIONS_READ)) return ROLE_TEXT.scopeReadDenied

      return this.placeReadDenied
    },
  },
  created: function () {
    this.search()
    this.initAuth()
    // 운영사 후보는 **부를 수 있을 때만** 읽는다(`callpopOperatorsMixin` 이 게이트를 갖는다) —
    // 리소스 없는 호출의 401 은 이 화면의 세션을 끝낸다
    this.loadOperators()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  /**
   * 디바운스 타이머를 소유한 자리가 이 컴포넌트이므로 정리도 여기다 — 화면을 떠난 뒤 깨어난 타이머는
   * 사라진 컴포넌트에서 `GET /place` 를 한 번 더 낸다(그 403 의 빨간 토스트는 다음 화면에 뜬다).
   */
  beforeDestroy: function () {
    if (this._placeSearchTimer) clearTimeout(this._placeSearchTimer)
    this.placeGuard.close()
  },
  watch: {
    'inputForm.accountId': function (newVal, oldVal) {
      if ('' != newVal && 'I' === this.inputForm.statu) {
        this.chkAccountId()
      }
    },
  },
  methods: {
    /** 템플릿이 읽는 술어 — 판정은 [roleIssuable] 하나이고 화면은 그것을 부를 뿐이다(비활성·툴팁 같은 값) */
    roleIssuable: roleIssuable,
    // 검색 조건 초기화 — 페이징·정렬 축은 [withPaging] 이 붙인다(기본 50건·첫 페이지·서버 기본 정렬)
    initSearchForm: function () {
      return withPaging({
        accountId: '',
        accountNm: '',
        useYn: '',
        nonLocked: '',
        nonExpired: '',
        certificateNonExpired: '',
      })
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',
        accountId: '',
        accountNm: '',
        accountPw: '',
        accountPwConfirm: '',
        useYn: 'Y',
        nonLocked: 'Y',
        nonExpired: 'Y',
        certificateNonExpired: 'Y',
        tel: '',
        telTmp: '',
        email: '',
        emailTmp: '',
      }
    },
    // 입력폼 오류 메세지 초기화
    initFormError: function () {
      return {
        accountId: '',
        accountNm: '',
        accountPw: '',
        accountPwConfirm: '',
        tel: '',
        email: '',
        // 발급 사슬·범위 거부(403)의 서버 문구가 앉는 자리 — 토스트가 사라져도 폼에 남는다
        auths: '',
        // 세 범위 칸(플레이스·운영사·관리점)의 자리([SCOPE_ERROR_FIELD]) — 고른 역할이 요구하는 소속을
        // 비운 채 저장하려 할 때의 문장이 그 칸에 앉는다([checkScopeAxis])
        scopes: '',
        operator: '',
        agency: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
        this.btn.openAuthDisabled = false
      }

      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].accountId
      }
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.formError = this.initFormError()
      this.resetScope([], null)

      this.dialogFormVisible = true
      this.btn.saveDisabled = false

      this.inputForm.title = this.$t('계정 추가')
    },
    /**
     * 다이얼로그를 여는 **읽기 한 곳** — 「수정」과 「권한 설정」이 같은 `GET /account/{id}` 를 쓴다.
     *
     * 이 403 은 「세션이 무효다」가 아니라 **「그 계정은 네가 발급할 수 있는 사슬 밖이다」** 는 서버의 답이다
     * (`AccountIssuePolicy.checkRead`). 목록도 이제 같은 사슬로 걸러지지만(보안 원장 ②), 목록을 읽은 뒤
     * 대상의 역할이 바뀌면 그 행은 열리지 않는다 — 기본값대로 두면 그 한 번의 클릭이 **로그아웃**이 된다.
     * 옵트아웃과 대체 동작은 [permittedRead] 가 갖고,
     * 여기서는 그 답을 화면에 남긴 뒤 **다이얼로그를 열지 않는다**(옵트아웃이 정당한 이유가 이 대체 동작이다).
     *
     * 액션 게이트([ACCOUNT_DETAIL_READ])도 같은 이유로 나머지 두 읽기와 같다 — `AccountGet` 이 없는 롤에서는
     * **보안 계층**의 403 이라 서버가 세션을 끊는다. 옵트아웃으로는 되살릴 수 없으므로 부르지 않는다.
     *
     * 403 이 **아닌** 실패(500·전송 오류)도 여기서 값으로 끝낸다 — [permittedRead] 는 그 갈래를 던지고,
     * 호출부(`up`·`openAuth`)는 `@click` 이라 Vue 가 반환 프라미스를 `await` 하지 않아 그대로 두면
     * 처리되지 않은 프라미스 거부가 된다([initAuth] 와 같은 이유). 답은 「못 읽었다」로 같지만 이유가
     * 다르므로 권한 문구를 빌려 쓰지 않는다(`READ_DENIED.FAILED` 와 같은 갈래).
     *
     * @returns {Promise<?object>} 못 읽었으면 `null`
     */
    loadAccountForEdit: async function (accountId) {
      let outcome

      try {
        outcome = await permittedRead(Object.assign({}, ACCOUNT_DETAIL_READ, { url: this.url + '/' + accountId }))
      } catch (error) {
        this.accountReadDenied = this.roleText.accountReadFailed

        return null
      }

      if (!outcome.allowed) {
        this.accountReadDenied = outcome.message || this.roleText.accountReadDenied

        return null
      }

      this.accountReadDenied = ''

      return outcome.data
    },
    // 수정
    up: async function () {
      const account = await this.loadAccountForEdit(this.selectData.accountId)

      if (!account) return

      // 비밀번호 두 칸은 **언제나 빈칸**으로 연다 — 서버는 더 이상 해시를 내리지 않고(보안 원장 ⑥),
      // 빈칸은 「그대로 둔다」는 뜻이다([passwordPatch])
      this.inputForm = Object.assign({}, account, blankPassword(), {
        telTmp: account.tel,
        emailTmp: account.email,
        statu: 'U',
        title: this.$t('계정 수정'),
      })

      this.formError = this.initFormError()
      this.resetScope(account.auths, account.scopes)

      this.dialogFormVisible = true
      this.btn.saveDisabled = false
    },
    /** 역할·범위 폼을 서버가 준 계정 정보로 되돌린다 — 다이얼로그를 여는 두 자리가 같은 변환을 쓴다 */
    resetScope: function (auths, scopes) {
      this.accountAuthIds = authIdsOf(auths)
      this.selectedAuthIds = this.accountAuthIds.slice()
      this.scopeForm = toScopeForm(scopes)
      this.placeOptions = []
      // 「지금까지의 응답은 전부 버린다」에는 '읽는 중'도 포함된다 — 파생 상태를 가드와 **같은 자리**에서
      // 끝내지 않으면, 버려진 요청의 `finally`(늦게 도착해 `isLatest` 가 거짓이다)가 이 플래그를 못 내려
      // 스피너가 굳고 [onPlaceFocus] 가 재조회를 영영 거부한다
      this.placeSearchLoading = false
      this.placeGuard.invalidate() // 다른 계정을 열었다 — 앞 계정의 후보 응답은 버린다
      // 관리점 축도 **같은 줄에서** 정리한다 — 그 선택기는 자기 후보가 누구의 것인지 모른다.
      // 다이얼로그가 `destroy-on-close` 없이 살아 있어, 안 지우면 앞 계정의 후보 위에서 새 값을 읽는다
      if (this.$refs.agencyPicker) this.$refs.agencyPicker.reset()

      // 바인딩된 플레이스의 이름을 보이려면 후보 목록이 있어야 한다(id 만 남으면 무엇에 묶였는지 못 읽는다).
      // 못 읽는 것이 이미 답인 경우에는 부르지 않는다 — 판정은 [placeScopeDenied] 한 곳이다
      if (!this.placeScopeDenied && this.scopeForm[SCOPE_TYPE.PLACE].length > 0) this.loadPlaceOptions('')
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchQuery(),
        function (result) {
          this.applyPage(result)

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true
          this.btn.openAuthDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
          // 새 목록에는 지난 「열 수 없다」가 남지 않는다
          this.accountReadDenied = ''
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('계정 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this)
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    /**
     * 저장 — 계정 정보 + 역할(`auths`) + 범위(`scopes`)를 한 번에 보낸다(서버 보고서 §3).
     *
     * 전송은 `this.$axios` 를 직접 쓴다. 레거시 `mainVue.$axios.add/up` 은 config 를 받지 못해
     * [ACCOUNT_WRITE_CONFIG] 의 403 옵트아웃을 실을 수 없고, 그러면 발급 사슬을 벗어난 저장 한 번이
     * 발급자를 로그아웃시킨다. 필드 오류 머지(`HttpError.messages` → `formError`)는 같은 함수를 쓴다.
     */
    save: async function () {
      this.formError = this.initFormError()

      const isInputDialog = this.dialogFormVisible

      if (!isInputDialog && !this.authDialogFormVisible) return

      // 비밀번호 축 — 판정은 [passwordPatch] 한 곳이다. 두 칸이 비면 두 키를 본문에서 빼고(서버가
      // 「그대로 둔다」로 읽는다) 값이 있으면 그대로 싣는다. 권한 설정 팝업에는 그 칸이 없으므로
      // 언제나 앞 갈래이고, 그래서 이 팝업의 저장도 해시를 되돌려 보내지 않는다
      const patch = passwordPatch(this.inputForm)

      if (!patch.ok) {
        this.formError[patch.field] = this.$t(patch.message)

        return
      }

      const isInsert = isInputDialog && 'I' === this.inputForm.statu

      // 범위 축의 길이 검사는 사라졌다 — 세 축이 모두 **고른 PK** 라 사람이 긴 문자열을 넣을 자리가 없다
      // (종전의 자유 텍스트 갈래는 B7-b 가 마스터 표를 세우면서 닫혔다). 남은 검사는 「비었는가」 하나다
      if (!this.checkRoleAxis(isInputDialog)) return
      if (!this.checkScopeAxis(isInputDialog)) return

      const payload = this.buildPayload(isInputDialog, patch.payload)
      const url = isInsert ? this.url : this.url + '/' + this.inputForm.accountId

      try {
        if (isInsert) {
          await this.$axios.post(url, payload, ACCOUNT_WRITE_CONFIG)
        } else {
          await this.$axios.put(url, payload, ACCOUNT_WRITE_CONFIG)
        }
      } catch (error) {
        this.applySaveError(error)

        return
      }

      this.mainVue.$message({ type: 'success', message: isInsert ? this.$t('등록 성공') : this.$t('수정 성공') })
      this.dialogFormVisible = false
      this.authDialogFormVisible = false
      this.search()
    },
    /**
     * **「권한 설정」 팝업에서 전부 해제한 저장만 막는다.**
     *
     * 빈 `auths` 의 뜻은 서버가 갈라 두었다 — `add` 는 `resolveAuths` 로 `mng` 하나를 채우고, `up` 은
     * `resolveAuthsForUpdate` 로 **대상의 현재 역할을 그대로 유지**한다(`ObjectUtils.isEmpty` 라 키를 빼도
     * `[]` 로 보내도 같다). 그러니 수정으로 역할이 사라지는 경로는 없고, 막을 값이 있는 것은 **아무것도
     * 바뀌지 않는데 「수정 성공」이 뜨는** 자리뿐이다: 역할 축만 고치는 권한 설정 팝업이 그렇다.
     *
     * 입력 폼은 비밀번호·연락처를 함께 보내므로 역할을 비운 저장에도 할 일이 있다 — 거기서 막으면 역할과
     * 무관한 수정까지 함께 막힌다(역할이 비어 있는 계정을 열면 아예 저장을 못 한다).
     *
     * 두 다이얼로그가 **같은 값**([selectedAuthIds])을 고르므로 판정은 「어느 다이얼로그인가」 하나다.
     *
     * @param {boolean} isInputDialog 입력 폼의 저장인가(아니면 권한 설정 팝업이다)
     * @returns {boolean} 저장해도 되는가
     */
    checkRoleAxis: function (isInputDialog) {
      if (isInputDialog || this.selectedAuthIds.length > 0) return true

      this.formError.auths = this.roleText.roleRequiredOnAuthDialog
      this.mainVue.$message({ type: 'warning', message: this.roleText.roleRequiredOnAuthDialog })

      return false
    },
    /**
     * **고른 역할이 요구하는 소속 칸이 비었으면 보내지 않고, 그 칸에 이유를 적는다.**
     *
     * 운영사·관리점·플레이스 관리자는 소속(범위)으로만 매장을 본다 — 비운 채 저장하면 역할은 있는데
     * 아무것도 안 보이는 계정이 되고, 만든 사람도 받은 사람도 이유를 볼 자리가 없다(리얼 2026-10-12).
     * 묶여 있던 소속을 지우는 저장도 같은 자리다: 자기 소속을 비운 총괄 운영사는 스스로 되돌리지 못한다.
     *
     * 판정 정본은 서버 `AccountIssuePolicy.check` 이고 여기는 같은 말을 **보내기 전에 그 칸에서** 한다.
     * 무엇이 필수인지는 칸을 그리는 것과 같은 자리가 정한다([missingScopesOf] — `utils/adminRole`).
     *
     * **입력 폼에서만 본다.** 「권한 설정」 팝업에는 소속 칸이 없어 채울 곳도 문장이 앉을 곳도 없다 — 그
     * 팝업은 조회 때 받은 범위를 그대로 되돌려 보내고, 역할만 바꿔 소속이 모자라게 된 저장은 서버가
     * 거절해 그 문장이 팝업에 그대로 남는다([applySaveError]).
     *
     * @param {boolean} isInputDialog 입력 폼의 저장인가
     * @returns {boolean} 저장해도 되는가
     */
    checkScopeAxis: function (isInputDialog) {
      if (!isInputDialog) return true

      const missing = missingScopesOf(this.selectedAuthIds, this.scopeForm)

      missing.forEach((scope) => {
        this.formError[SCOPE_ERROR_FIELD[scope.type]] = scope.message
      })

      return missing.length === 0
    },
    /**
     * 서버로 나가는 본문.
     *
     * 역할 축은 **두 다이얼로그가 같은 값**을 쓴다([selectedAuthIds]) — 입력 폼은 셀렉트가, 권한 설정 팝업은
     * 표의 체크가 그 값을 고친다. 하나도 없으면 `auths` 를 **싣지 않고**, 그 뜻은 서버가 갈라 읽는다:
     * 생성은 `mng` 하나가 되고(서버 보고서 §3), 수정은 대상의 **현재 역할을 그대로 유지**한다
     * (`resolveAuthsForUpdate`). 권한 설정 팝업에서 전부 해제한 저장만 [checkRoleAxis] 가 앞에서 막는다 —
     * 그 자리에서는 아무것도 바뀌지 않는 저장이 「수정 성공」으로 보이기 때문이다.
     *
     * 범위(`scopes`)는 입력 폼의 축이라 권한 설정 팝업에서는 서버가 준 값을 그대로 되돌려 보낸다.
     *
     * @param {boolean} isInputDialog 입력 폼의 저장인가
     * @param {object} form 비밀번호 축을 이미 판정한 본문([passwordPatch] 의 `payload`)
     */
    buildPayload: function (isInputDialog, form) {
      const payload = Object.assign({}, form)

      if (this.selectedAuthIds.length > 0) {
        payload.auths = this.selectedAuthIds.map((authId) => ({ authId }))
      } else {
        delete payload.auths
      }

      if (isInputDialog) payload.scopes = toScopePayload(this.scopeForm, this.selectedAuthIds)

      return payload
    },
    /** 실패를 폼에 남긴다 — 403(발급 사슬·범위 거부)은 서버 문구를 역할 칸에 그대로 둔다 */
    applySaveError: function (error) {
      if (!(error instanceof HttpError)) throw error

      if (httpStatusOf(error) === 403) {
        this.formError.auths = error.message

        return
      }

      mergeErrors(this.formError, error.messages)
    },
    // 계정 아이디 체크
    chkAccountId: function () {
      this.mainVue.$axios.patchNonLoading(
        this.url + '/chk/' + this.inputForm.accountId,
        null,
        null,
        function (result) {
          if ('' == result) {
            this.formError.accountId = ''
            this.btn.saveDisabled = false
          } else {
            this.formError.accountId = this.$t('이미 사용중인 아이디입니다.')
            this.btn.saveDisabled = true
          }
        }.bind(this),
        false
      )
    },
    /**
     * 권한(역할) 목록 — **부를 수 있을 때만 부른다**([AUTH_LIST_READ] 의 액션 게이트).
     *
     * 못 읽으면 표가 비고, 역할 목록은 `adminRoleCatalog` 의 사본이 세운다 — 목록이 비면 역할을 못 고르고
     * 계정 발급 자체가 불가능해진다. 403 이 아닌 실패도 **같은 답**이다(사본 목록) — `created` 가 `await`
     * 하지 않으므로 여기서 값으로 끝내지 않으면 처리되지 않은 프라미스 거부가 된다.
     */
    initAuth: async function () {
      try {
        const outcome = await permittedRead(
          Object.assign({}, AUTH_LIST_READ, { params: { authId: '', authNm: '', useYn: '' } })
        )

        this.authTableData = (outcome.allowed && outcome.data) || []
      } catch (error) {
        this.authTableData = []
      }
    },
    /**
     * 권한 설정 팝업 — 읽기는 [loadAccountForEdit] 한 곳이다(같은 403 을 두 번 다루지 않는다).
     *
     * 표도 선택 복원도 [roleOptions] 를 본다. 종전에는 `authTableData` 를 직접 읽어, `GET /auth` 가 막힌
     * 계정(콜팝 관리자는 `AuthSearch` 가 없다)에서 **빈 표**가 떴다 — 버튼은 있는데 고를 것이 없는 화면이다.
     */
    openAuth: async function () {
      const account = await this.loadAccountForEdit(this.selectData.accountId)

      if (!account) return

      // 이 팝업에는 비밀번호 칸이 없다 — 그래도 **폼에 해시가 들어오지 못하게** 빈칸으로 덮는다
      // (옛 서버가 아직 `accountPw` 를 내리는 환경에서도 저장이 그것을 되돌려 보내지 않는다)
      this.inputForm = Object.assign({}, account, blankPassword())
      this.formError = this.initFormError()
      // 역할 축은 두 다이얼로그가 같은 값을 쓴다 — 목록(사용 중지 역할 보존)도 저장도 이것을 읽는다
      this.accountAuthIds = authIdsOf(account.auths)
      this.selectedAuthIds = this.accountAuthIds.slice()
      this.authDialogFormVisible = true

      this.btn.saveDisabled = false

      var interval = setInterval(
        function () {
          if (this.$refs.authTable) {
            const rows = this.roleOptions

            this.$refs.authTable.clearSelection()

            for (var i = 0, len = rows.length; i < len; i++) {
              if (this.selectedAuthIds.indexOf(rows[i].authId) > -1) {
                this.$refs.authTable.toggleRowSelection(rows[i], true)
              }
            }

            clearInterval(interval)
          }
        }.bind(this),
        10
      )
    },
    // 권한 리스트 체크 이벤트 — 고른 역할이 앉는 자리는 입력 폼 셀렉트와 **같다**
    authHandleRowChecked: function (selection) {
      this.selectedAuthIds = authIdsOf(selection)
    },
    /** 처음 열 때 한 번은 후보를 보여 준다 — 원격 검색은 입력이 있어야 돌아서 빈 목록만 보인다 */
    onPlaceFocus: function () {
      if (this.placeOptions.length > 0 || this.placeSearchLoading) return

      this.loadPlaceOptions('')
    },
    /** 플레이스 범위 후보 — 입력할 때마다 부르므로 눌러 담는다(300ms) */
    searchPlace: function (query) {
      if (this._placeSearchTimer) clearTimeout(this._placeSearchTimer)

      this._placeSearchTimer = setTimeout(
        function () {
          this.loadPlaceOptions(query)
        }.bind(this),
        300
      )
    },
    /**
     * 플레이스 후보 조회 — **조회 권한을 이 함수가 갖는다**([PLACE_OPTIONS_READ]).
     *
     * 계정을 발급할 수 있는 계정이 플레이스를 볼 수 있다는 보장은 없다(다른 축이다). 액션이 없으면
     * **부르지 않고**, 서버가 403 으로 답하면 그 문장을 남긴다 — 어느 쪽이든 **이미 묶인 범위는 그대로
     * 둔다**: 후보를 못 읽는 것과 범위를 지우는 것은 다른 말이고, 저장은 전체 교체라 지우면 조용히 사라진다.
     * 칸은 [placeScopeDenied] 로 읽기 전용이 되고 `scopeForm` 은 손대지 않으므로 저장에 그대로 실린다.
     *
     * 이미 고른 값은 목록에서 사라져도 남아야 하므로(다시 검색하면 후보가 바뀐다) 선택된 id 의 옵션은
     * 보존한다 — 안 그러면 태그가 id 숫자로 되돌아간다. 응답 안에서도 같은 규칙이라, 상한은 묶이지 않은
     * 후보에만 걸린다([placeOptionsOf]).
     *
     * 늦게 온 응답은 버린다([placeGuard]) — 300ms 디바운스는 순서를 보장하지 않는다.
     *
     * **호출부는 `await` 하지 않아도 된다**: 403 은 값으로 접고([permittedRead]) 그 밖의 실패는 여기서 끝낸다
     * (인터셉터가 이미 토스트로 말했다). 세 호출부에 `.catch` 를 붙이면 같은 규칙이 세 벌이 된다.
     *
     * @returns {Promise<object>} 호출부가 읽는 조회 결과([permittedRead])
     */
    loadPlaceOptions: async function (query) {
      const selected = this.placeOptions.filter((option) => this.scopeForm[SCOPE_TYPE.PLACE].indexOf(option.id) > -1)
      const seq = this.placeGuard.begin()

      this.placeSearchLoading = true

      try {
        const outcome = await permittedRead(Object.assign({}, PLACE_OPTIONS_READ, { params: { q: query || '' } }))

        if (!this.placeGuard.isLatest(seq)) return outcome

        if (!outcome.allowed) {
          this.placeReadDenied = outcome.message || this.roleText.scopeReadDenied
          this.placeOptions = selected

          return outcome
        }

        this.placeReadDenied = ''

        const items = (outcome.data && outcome.data.items) || []
        // 상한은 **안 묶인 후보**에만 걸린다([placeOptionsOf]) — 묶인 것이 잘리면 태그가 id 로 되돌아간다.
        // 「고른 값은 후보에서 사라져도 남긴다」는 관용구는 [keepSelectedOptions] 한 곳이다(관리점 선택기와 같다)
        const found = placeOptionsOf(items, this.scopeForm[SCOPE_TYPE.PLACE])

        this.placeOptions = keepSelectedOptions(selected, found, this.scopeForm[SCOPE_TYPE.PLACE])

        return outcome
      } catch (error) {
        // 403 이 아닌 실패 — 「권한 밖」이 아니라 진짜 실패다. 이미 묶인 범위는 그대로 두고 값으로 끝낸다
        // (문구는 인터셉터가 이미 띄웠고, 권한 안내를 빌려 쓰면 못 읽은 이유를 화면이 틀리게 말한다)
        if (this.placeGuard.isLatest(seq)) this.placeOptions = selected

        return deniedRead(READ_DENIED.FAILED)
      } finally {
        if (this.placeGuard.isLatest(seq)) this.placeSearchLoading = false
      }
    },
  },
}
</script>

<style scoped>
.account-role,
.account-scope-place,
.account-scope-operator,
.account-scope-agency {
  width: 100%;
}

.account-read-denied {
  margin-top: 8px;
}

.account-hint {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
}

.account-role-fallback {
  margin-bottom: 8px;
}

/* 권한 설정 팝업에는 폼이 없다 — `el-form-item__error` 와 같은 낯빛으로 역할 축의 답을 그린다 */
.account-auth-error {
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 1.5;
  color: #f56c6c;
}
</style>
